<article class="block-usp section-outset-y container">
  <h2
    class="text-max-width h1 splitting splitting--word-in"
    *ngIf="block.title"
    [innerHTML]="block.title | highlight : 'font-display text-primary-gradient'"
    data-split
  ></h2>

  <!--<h2 *ngIf="block.title" class="block-team__title fs-display-2 fw-bold mb-4">
    <ngx-dynamic-hooks
      [options]="{ sanitize: false, updateOnPushOnly: true }"
      [content]="block.title | highlight : 'text-primary-gradient'"
      splitting
      [duration]="400"
      [context]="{ delayAnimation: 800, startShapeAnimation: inviewPort }"
      [startTextAnimation]="inviewPort"
      class="splitting splitting--word-in"
    ></ngx-dynamic-hooks>
  </h2>-->

  <ul *ngIf="block.usps?.length" class="usp-list row anim--list-stagger" [style.--usp-list-count]="block.usps!.length">
    <li
      *ngFor="let usp of block.usps; let i = index; trackBy: trackByFn"
      class="usp-list__item col-12 col-sm-6 col-md-4 col-lg-3 anim--stagger-list-item"
      [style.--list-index]="i"
    >
      <div class="usp-card">
        <fstr-image
          class="usp-card__icon my-3 d-block"
          *ngIf="usp.image"
          [alt]="usp.image.alt || usp.title"
          [imageSizes]="[400, 800, 900]"
          [image]="usp.image"
        ></fstr-image>
        <p class="usp-card__title" *ngIf="usp.title" [innerHTML]="usp.title | highlight : 'fw-bold'"></p>
      </div>
    </li>
  </ul>
</article>
